export default "__VITE_ASSET__Bm4XN0KH__"